import e from "../utils/propValidator.mjs";
const r = {
  type: String,
  default: "medium",
  validator: (a) => e(a, ["small", "medium", "large"])
};
export {
  r as default
};
